import React from 'react';
import { Checkbox, Row, Col, Typography } from 'antd';

const { Text } = Typography;

const PermissionModuleRow = ({ module, handleModuleSelectAll, handleIndividualPermissionChange, selectedPermissions }) => {

  const allModuleChecked = module.permissions.every(p => selectedPermissions.includes(p.value));

  return (
    <Row
      key={module.key}
      align="middle"
      style={{ height: '40px', borderBottom: '1px solid #f0f0f0' }}
    >
      <Col span={4}>
        <Text>{module.name}</Text>
      </Col>

      <Col span={2}>
        <Checkbox
          onChange={handleModuleSelectAll(module.key, module.permissions.map(p => p.value))}
          checked={allModuleChecked}
        >
          All
        </Checkbox>
      </Col>

      <Col span={18}>
        <Row gutter={16}>
          {module.permissions.map(p => (
            <Col span={6} key={p.value}>
              <Checkbox
                checked={selectedPermissions.includes(p.value)}
                onChange={(e) => handleIndividualPermissionChange(module.key, module.permissions.map(p => p.value))(e, p.value)}
              >
                {p.label}
              </Checkbox>
            </Col>
          ))}
        </Row>
      </Col>
    </Row>
  );
};

export default PermissionModuleRow;
